<template>
  <div class="app-container message-template-add">
    <basic-container v-loading="loading">
      <div class="operation">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="submit">保存</el-button>
      </div>
      <el-row class="one-line">
        <el-col :span="2">分类</el-col>
        <el-col :span="16">
          <el-input :maxlength="10" v-model="category"></el-input>
        </el-col>
      </el-row>
      <el-row class="one-line">
        <el-col :span="2">问题</el-col>
        <el-col :span="16">
          <el-input type="textarea" :rows="5" :maxlength="100" v-model="content"></el-input>
        </el-col>
      </el-row>
    </basic-container>
  </div>
</template>
<script>
import { addObj } from '@/api/setting/template/messageTemplate'

export default {
  data () {
    return {
      category: '',
      content: '',
      loading: false
    }
  },
  methods: {
    cancel () {
      this.$router.$avueRouter.closeTag()
      this.$router.go(-1)
    },
    validate () {
      if (!this.category) {
        this.$message({
          message: '分类不能为空',
          type: 'error'
        })
        return false
      }
      if (!this.content) {
        this.$message({
          message: '内容不能为空',
          type: 'error'
        })
        return false
      }
      return true
    },
    getParams () {
      let params = {
        category: this.category,
        content: this.content
      }
      return params
    },
    submit () {
      if (!this.validate()) {
        return false
      }
      this.loading = true
      addObj(this.getParams()).then(response => {
        if (response.data.data) {
          this.loading = false
          this.$message({
            message: '创建成功',
            type: 'success'
          })
          this.$router.$avueRouter.closeTag()
          this.$router.push({
            path: `/setting/template/message/detail/${response.data.data}`
          })
        }
      }).catch(error => {
        console.error(error)
        this.$message({
          message: '创建失败',
          type: 'error'
        })
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss">
.message-template-add {
  .operation {
    text-align: right
  }
}
</style>

